import React from 'react';
import currency from 'currency.js';
import { getOptionPrice } from '../../utils/functions';
import styles from './HolidayDisplay.module.scss';
import Modal from '../PackageBuilders/MultiPose/Modal';
import modalStyles from '../PackageBuilders/MultiPose/ReviewModal.module.scss';

export default function HolidayOption({ option, schoolId }) {
  const price = getOptionPrice(option, schoolId);

  return (
    <Modal>
      <Modal.Trigger className={styles.holidayOption}>
        <div>
          <img alt={`Option ${option.name} available for purchase`} src={option.imageUrl} />
          <p className={styles.name}>{option.name}</p>
          <p className={styles.price}>{currency(price.price).format()}</p>
        </div>
      </Modal.Trigger>
      <Modal.Content className={modalStyles.content}>
        <Modal.Close>X</Modal.Close>
      </Modal.Content>
    </Modal>
  );
}
